// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__33yIu","indicator":"Tabs_indicator__4ZS4U","tab":"Tabs_tab__A-iQu","navigation":"Tabs_navigation__g1NSF","options":"Tabs_options__BNtMQ"};